<template>
  <ul class="home-list">
    <li @click="newQrcode">
      <img src="@/assets/images/createCode.png" alt="" />
      <p class="detail mb-20 ml-20">新建二维码</p>
    </li>
    <li @click="beComeQrcode">
      <img src="@/assets/images/effective.png" alt="" />
      <p class="detail mb-20 ml-20">生效中的二维码</p>
    </li>
    <li @click="terminationQrcode">
      <img src="@/assets/images/end.png" alt="" />
      <p class="detail mb-20 ml-20">已终止的二维码</p>
    </li>
    <li @click="productStatistics">
      <img src="@/assets/images/count.png" alt="" />
      <p class="detail mb-20 ml-20">扫码统计</p>
    </li>
  </ul>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {
    terminationQrcode() {
      this.$router.push("/marketing/endApplication");
    },
    beComeQrcode() {
      this.$router.push("/marketing/SXApplication");
    },
    newQrcode() {
      this.$router.push("/createCode/newQrCode");
    },
    productStatistics() {
      this.$router.push("/scan/statistics");
    }
  }
};
</script>
<style lang="sass" scoped>
.home-list
  display: flex
  width: 100%
  flex-wrap: wrap
  li
    width: 50%
    display: flex
    img
      width: 123px
      height: 123px
      cursor: pointer
    p
      line-height: 123px
      cursor: pointer
</style>
